import Axios from 'axios';
import * as TokenHelpers from '../utils/tokenHelpers';
import * as ApiHelper from '../utils/apiHelper';

export function getShipment(data){
    let path = ApiHelper.API_ROOT+'/customers/shipposhipment';
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());

    return new Promise((resolve, reject) => {
        Axios({
            url: path,
            method: 'POST',
            data: data,
            headers: headers,
        })    
            .then(function (response) {
                resolve(response.data);
            }).catch(ApiHelper.handleUserAuth).catch(function (error) {
                reject({ error: error.response.data });
            });   
    });
}



// WEBPACK FOOTER //
// ./src/services/shippo.js